import Styled from 'styled-components';

export const Input = Styled.input`
  height: 40px;
  border-radius: 5px;
  border: 0.1px solid rgba(0,0,0,.2);
  background: transparent;
  padding-left: 5px !important;
  //border-color: ${props => props.theme.colors.secundary};
  display:flex;
  font-size: 40px !important;
  :focus{
   border: 0.5px solid rgba(247, 79, 2); !important;
  }
`;

export const Container = Styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;

export const Label = Styled.label`
  font-size: ${props => props.theme.fontSize.small}; 
  font-weight: bold; 
`;

export const MessageInput = Styled.label`
color: red;
font-size: 14px;
`